﻿export default class TrapFocus {

	private container: HTMLElement;
	private lastFocusableElement?: HTMLLinkElement;
	private keydownFunction: any;

	constructor(container, lastFocusableElement?) {

		if (!container) return;

		this.container = container;
		this.lastFocusableElement = lastFocusableElement;
		this.init();

	}

	private init() {
		this.keydownFunction = this.handleKeyDown.bind(this);
		document.addEventListener('keydown', this.keydownFunction);
	}

	private handleKeyDown(e) {

		const allFocusableElements = this.container.querySelectorAll('button, a');
		const firstFocusableElement = allFocusableElements[0] as HTMLLinkElement;
		const lastFocusableElement = this.lastFocusableElement ? this.lastFocusableElement : allFocusableElements[allFocusableElements.length - 1] as HTMLLinkElement;
		const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) { // if shift key pressed for shift + tab combination
			if (document.activeElement === firstFocusableElement) {
				lastFocusableElement.focus();
				e.preventDefault();
			}
		} else { // if tab key is pressed
			if (document.activeElement === lastFocusableElement) {
				firstFocusableElement.focus(); 
				e.preventDefault();
			}
		}
	}

	public removeListener() {
		document.removeEventListener('keydown', this.keydownFunction);
	}

}
